import React from 'react';
import classnames from 'classnames';
import parse from 'html-react-parser';

import * as styles from './Terms.module.scss';

const Terms = ({ data }) => {
  return (
    <div className={classnames(styles.wrap, 'cr-wrap')}>
      <div className={styles.top}>
        <h1 className="cr-h2">{data.title && data.title}</h1>
        <p className="cr-lead cr-text-2">{data.subtitle && data.subtitle}</p>
      </div>

      <div className={styles.content}>{parse(data.content)}</div>
    </div>
  );
};

export default Terms;
